// LiveStreamChatroom.js
import { connect } from 'react-redux';

import {
  LIVESTREAM_CHAT_LIST_LIMITATION,
  LIVESTREAM_CHAT_SCROLL_DETECT_ITEM_COUNT,
} from '../RemoteConfigKeys.js';

import LiveStreamChatroom from '../component/LiveStreamChatroom.jsx';
import getMeData from '../selector/getMeData.js';
import getLiveStreamChats from '../selector/getLiveStreamChats.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import setLiveStreamChatroom from '../action/setLiveStreamChatroom.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const chatIds = getLiveStreamChats(state, streamId);
  const latestMessageId = chatIds[chatIds.length - 1];
  const latestMessageSenderId = getLiveStreamData(
    state,
    [streamId, 'chat', latestMessageId],
    'senderId'
  );
  return {
    meId,
    latestMessageId,
    latestMessageSenderId,
    chatListLimitation: getRemoteConfigData(
      state,
      LIVESTREAM_CHAT_LIST_LIMITATION
    ),
    chatScrollDetectItemCount: getRemoteConfigData(
      state,
      LIVESTREAM_CHAT_SCROLL_DETECT_ITEM_COUNT
    ),
    chatIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setLiveStreamChatroom: ({ isScrolling }) =>
      dispatch(setLiveStreamChatroom({ isScrolling })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamChatroom);
